{
  "clinicalNotes": "மருத்துவ குறிப்புகள்",
  "noteType": "குறிப்பு வகை",
  "author": "ஆசிரியர்",
  "dateTime": "தேதி/நேரம்",
  "content": "உள்ளடக்கம்",
  "addNote": "குறிப்பைச் சேர்",
  "editNote": "குறிப்பைத் திருத்து",
  "signNote": "குறிப்பில் கையெழுத்திடு",
  "signed": "கையெழுத்திடப்பட்டது",
  "unsigned": "கையெழுத்திடப்படவில்லை",
  "types": {
    "progressNote": "முன்னேற்றக் குறிப்பு",
    "admissionNote": "சேர்க்கைக் குறிப்பு",
    "dischargeNote": "வீடு திரும்புதல் குறிப்பு",
    "consultNote": "ஆலோசனைக் குறிப்பு",
    "procedureNote": "செயல்முறைக் குறிப்பு"
  },
  "editor": {
    "newNote": "புதிய குறிப்பு",
    "titlePlaceholder": "குறிப்புத் தலைப்பு…",
    "create": "உருவாக்கு",
    "cancel": "ரத்து",
    "cosignFilterLabel": "என் இணைக் கையொப்பம் தேவையான குறிப்புகளை மட்டும் காட்டு",
    "emptyNoCosign": "உங்கள் இணைக் கையொப்பம் தேவைப்படும் குறிப்புகள் இல்லை",
    "emptyNoNotes": "இன்னும் குறிப்புகள் இல்லை",
    "emptySelection": "ஒரு குறிப்பைத் தேர்வு செய்யுங்கள் அல்லது புதிதாக உருவாக்குங்கள்",
    "emptySelectionHint": "இடதுபுற பட்டியிலிருந்து தேர்வு செய்யுங்கள் அல்லது \"+ புதிய குறிப்பு\" என்பதைக் கிளிக் செய்து தொடங்குங்கள்.",
    "unknownAuthor": "தெரியாதது",
    "needsCosignBadge": "இணைக் கையொப்பம் தேவை",
    "amendmentBanner": "குறிப்பு #{{parentId}} இன் திருத்தம் — காரணம்: {{reason}}",
    "signedBanner": "{{name}} {{when}} அன்று கையெழுத்திட்டார் — இந்தக் குறிப்பு படிக்க மட்டுமே.",
    "signedByFallback": "மருத்துவர்",
    "saving": "சேமிக்கப்படுகிறது…",
    "autoSaved": "தானாகச் சேமிக்கப்பட்டது",
    "actions": {
      "saveDraft": "வரைவைச் சேமி",
      "signNote": "குறிப்பில் கையெழுத்திடு",
      "amend": "திருத்து",
      "cosign": "இணைக் கையொப்பம்",
      "printLabel": "குறிப்பை அச்சிடு"
    },
    "copyForward": "முந்தைய குறிப்பை நகலெடு",
    "copyForwardHint": "{{date}} அன்று கையொப்பமிட்ட குறிப்பை நகலெடுக்கும் — ஒவ்வொரு வரியையும் மறுபரிசீலனை செய்யவும்",
    "copiedForwardBadge": "நகலெடுக்கப்பட்டது"
  },
  "dialog": {
    "sign": {
      "title": "குறிப்பில் கையெழுத்திடு",
      "body": "இந்தக் குறிப்பில் கையெழுத்திட விரும்புகிறீர்களா? இந்தச் செயல் திரும்பப்பெற இயலாது. கையெழுத்திட்ட பிறகு குறிப்பு படிக்க மட்டுமே ஆகும்.",
      "cancel": "ரத்து",
      "confirm": "கையொப்பத்தை உறுதி செய்"
    },
    "amend": {
      "title": "குறிப்பைத் திருத்து",
      "body": "இந்தத் திருத்தத்திற்கான காரணத்தைக் குறிப்பிடுங்கள். குறிப்பு புதுப்பிக்கப்பட்டு திருத்தப்பட்டது எனக் குறிக்கப்படும்.",
      "reasonPlaceholder": "திருத்தக் காரணம்…",
      "cancel": "ரத்து",
      "confirm": "திருத்தத்தை உறுதி செய்"
    },
    "cosign": {
      "title": "குறிப்பில் இணைக் கையொப்பம்",
      "body": "இந்தக் குறிப்பில் இணைக் கையெழுத்திட விரும்புகிறீர்களா? நீங்கள் இதன் உள்ளடக்கத்தைப் பார்வையிட்டு ஒப்புக்கொண்டதைக் குறிக்கும்.",
      "cancel": "ரத்து",
      "confirm": "இணைக் கையொப்பத்தை உறுதி செய்"
    }
  },
  "toast": {
    "created": "குறிப்பு உருவாக்கப்பட்டது",
    "createFailed": "குறிப்பை உருவாக்க முடியவில்லை",
    "titleRequired": "தயவுசெய்து குறிப்புத் தலைப்பை உள்ளிடவும்",
    "draftSaved": "வரைவு சேமிக்கப்பட்டது",
    "signed": "குறிப்பு வெற்றிகரமாகக் கையெழுத்திடப்பட்டது",
    "signFailed": "குறிப்பில் கையெழுத்திட முடியவில்லை",
    "amended": "குறிப்பு வெற்றிகரமாகத் திருத்தப்பட்டது",
    "amendFailed": "குறிப்பைத் திருத்த முடியவில்லை",
    "amendReasonRequired": "திருத்தக் காரணத்தைக் குறிப்பிடவும்",
    "cosigned": "குறிப்பு வெற்றிகரமாக இணைக் கையொப்பமிடப்பட்டது",
    "cosignFailed": "குறிப்பில் இணைக் கையொப்பமிட முடியவில்லை"
  },
  "status": {
    "draft": "வரைவு",
    "unsigned": "கையெழுத்திடப்படவில்லை",
    "signed": "கையெழுத்திடப்பட்டது",
    "amended": "திருத்தப்பட்டது",
    "cosigned": "இணைக் கையொப்பமிடப்பட்டது",
    "cosignNeeded": "இணைக் கையொப்பம் தேவை",
    "pendingSignature": "கையொப்பம் நிலுவையில்",
    "addendum": "இணைப்புக் குறிப்பு",
    "cosignPending": "இணைக் கையொப்பம் நிலுவையில்"
  },
  "worklist": {
    "title": "கையெழுத்திடாத குறிப்புகள் பணிப்பட்டியல்",
    "backToDashboard": "டாஷ்போர்டு",
    "filtersHeading": "வடிகட்டிகள்",
    "filterAllNoteTypes": "அனைத்து குறிப்பு வகைகள்",
    "filterAllStatuses": "அனைத்து நிலைகள்",
    "filterAuthorPlaceholder": "ஆசிரியரால் வடிகட்டு…",
    "dateFromAria": "தொடக்க தேதி",
    "dateToAria": "முடிவு தேதி",
    "columns": {
      "patient": "நோயாளி",
      "mrn": "MRN",
      "noteType": "குறிப்பு வகை",
      "noteTitle": "தலைப்பு",
      "author": "ஆசிரியர்",
      "created": "உருவாக்கப்பட்டது",
      "status": "நிலை",
      "actions": "செயல்கள்"
    },
    "actions": {
      "signSelected": "தேர்ந்தெடுத்தவற்றில் கையெழுத்திடு ({{count}})",
      "signing": "கையெழுத்திடுகிறது…",
      "open": "திற",
      "refresh": "புதுப்பிக்கவும்"
    },
    "loading": "குறிப்புகள் ஏற்றப்படுகின்றன…",
    "empty": "கையெழுத்திடாத குறிப்புகள் இல்லை",
    "loadError": "கையொப்பமிடப்படாத குறிப்புகளை ஏற்ற முடியவில்லை",
    "retry": "மீண்டும் முயல்க",
    "toast": {
      "noneSelected": "எந்த குறிப்பும் தேர்ந்தெடுக்கப்படவில்லை",
      "signed_one": "{{count}} குறிப்பு வெற்றிகரமாகக் கையெழுத்திடப்பட்டது",
      "signed_other": "{{count}} குறிப்புகள் வெற்றிகரமாகக் கையெழுத்திடப்பட்டன",
      "signFailed": "சில குறிப்புகளில் கையெழுத்திட முடியவில்லை",
      "partiallySigned_one": "{{count}} குறிப்பு கையெழுத்திடப்பட்டது, {{failed}} தோல்வி",
      "partiallySigned_other": "{{count}} குறிப்புகள் கையெழுத்திடப்பட்டன, {{failed}} தோல்வி"
    }
  },
  "type": {
    "progress": "முன்னேற்றக் குறிப்பு",
    "historyPhysical": "H&P",
    "admission": "சேர்க்கைக் குறிப்பு",
    "discharge": "வீடு திரும்புதல் சுருக்கம்",
    "consult": "ஆலோசனை",
    "procedure": "செயல்முறைக் குறிப்பு",
    "operative": "அறுவை சிகிச்சைக் குறிப்பு",
    "nursing": "செவிலியக் குறிப்பு"
  },
  "template": {
    "list": {
      "title": "குறிப்பு வார்ப்புருக்கள்",
      "backToDashboard": "டாஷ்போர்டு",
      "newButton": "புதிய வார்ப்புரு",
      "columns": {
        "name": "பெயர்",
        "noteType": "குறிப்பு வகை",
        "specialty": "சிறப்புத்துறை",
        "sections": "பகுதிகள்",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "active": "செயலில்",
      "inactive": "செயலில் இல்லை",
      "loading": "வார்ப்புருக்கள் ஏற்றப்படுகின்றன…",
      "empty": "வார்ப்புருக்கள் இல்லை. தொடங்க ஒன்றை உருவாக்குங்கள்.",
      "previewTitle": "வார்ப்புரு முன்னோட்டம்: {{name}}",
      "emptySection": "(காலியானது)",
      "tooltips": {
        "preview": "முன்னோட்டம்",
        "edit": "திருத்து",
        "activate": "செயல்படுத்து",
        "deactivate": "முடக்கு"
      },
      "toast": {
        "statusUpdated": "வார்ப்புரு நிலை புதுப்பிக்கப்பட்டது"
      }
    },
    "form": {
      "editTitle": "வார்ப்புருவைத் திருத்து",
      "createTitle": "வார்ப்புருவை உருவாக்கு",
      "fields": {
        "name": "வார்ப்புரு பெயர்",
        "noteType": "குறிப்பு வகை",
        "specialty": "சிறப்புத்துறை",
        "sections": "பகுதிகள்"
      },
      "required": "*",
      "namePlaceholder": "எ.கா., நிலையான முன்னேற்றக் குறிப்பு",
      "selectNoteType": "வகையைத் தேர்வு…",
      "selectSpecialty": "சிறப்புத்துறையைத் தேர்வு…",
      "addSection": "பகுதியைச் சேர்",
      "sectionNamePlaceholder": "பகுதியின் பெயர் (எ.கா., முதன்மை புகார்)",
      "sectionDefaultPlaceholder": "இந்தப் பகுதியின் இயல்புநிலை உள்ளடக்கம்…",
      "cancel": "ரத்து",
      "create": "வார்ப்புருவை உருவாக்கு",
      "update": "வார்ப்புருவை புதுப்பி",
      "toast": {
        "created": "வார்ப்புரு உருவாக்கப்பட்டது",
        "updated": "வார்ப்புரு புதுப்பிக்கப்பட்டது",
        "saveFailed": "வார்ப்புருவைச் சேமிக்க முடியவில்லை",
        "nameAndTypeRequired": "பெயரும் குறிப்பு வகையும் அவசியம்",
        "atLeastOneSection": "குறைந்தது ஒரு பகுதி தேவை"
      }
    },
    "specialty": {
      "general": "பொது மருத்துவம்",
      "internalMedicine": "உள் மருத்துவம்",
      "surgery": "அறுவை சிகிச்சை",
      "pediatrics": "குழந்தை மருத்துவம்",
      "cardiology": "இதயவியல்",
      "neurology": "நரம்பியல்",
      "orthopedics": "எலும்பியல்",
      "emergencyMedicine": "அவசர மருத்துவம்"
    },
    "scope": {
      "personal": "தனிப்பட்ட",
      "group": "குழு",
      "global": "முழு மருத்துவமனை"
    },
    "state": {
      "draft": "வரைவு",
      "published": "வெளியிடப்பட்டது"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "தடிமன்",
      "italic": "சாய்வு",
      "list": "பட்டியல்",
      "templates": "வார்ப்புருக்கள் / ஸ்மார்ட் சொற்றொடர்கள்",
      "saved": "சேமிக்கப்பட்டது {{time}}",
      "notSaved": "சேமிக்கப்படவில்லை",
      "charactersLabel": "எழுத்துகள்",
      "save": "{{noteType}} ஐ சேமிக்கவும்",
      "placeholder": "உங்கள் {{noteType}} ஐ தட்டச்சு செய்யத் தொடங்கவும்… ஸ்மார்ட் சொற்றொடர்களைத் தூண்ட \".\" ஐப் பயன்படுத்தவும்.",
      "smartPhrases": {
        "patientName": "நோயாளியின் பெயர்",
        "mrn": "எம்ஆர்என்",
        "dateOfBirth": "பிறந்த தேதி",
        "allergies": "ஒவ்வாமை",
        "vitals": "உயிர் அறிகுறிகள்",
        "medications": "மருந்துகள்",
        "problemList": "பிரச்சினை பட்டியல்"
      }
    }
  }
}
